import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Tabs, Tab } from 'react-bootstrap';

// Helpers de formulário
import PaymentOrdersTrainingHoursTab from './PaymentOrdersTrainingHoursTab';
import PaymentOrdersDailyInternationalTab from './PaymentOrdersDailyInternationalTab';
import PaymentOrdersDailyNationalTab from './PaymentOrdersDailyNationalTab';
import getLocale from '../../../i18n/getLocale';

class PaymentOrdersTrainingTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
    };

    this.locale = getLocale();

  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  render() {
    var self = this;
    return (
<div>
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
    <Tab eventKey={1} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabHoras.tituloTab}>
      <PaymentOrdersTrainingHoursTab RequestApi={this.props.request_api} refreshHours={this.props.refreshHours}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_hours={this.props.payment_order_payments_hours} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={2} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabNacional.tituloTab}>
      <PaymentOrdersDailyNationalTab RequestApi={this.props.request_api} refreshNationals={this.props.refreshNationals}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_daily_national={this.props.payment_order_payments_daily_national} payment_order_data={this.props.payment_order_data} />
    </Tab>
    <Tab eventKey={3} title={this.locale.OrdensDePagamento.EditarOrdemDePagamento.tabTreinamentos.tabInternacional.tituloTab}>
      <PaymentOrdersDailyInternationalTab RequestApi={this.props.request_api} refreshInternationals={this.props.refreshInternationals}  handleAlert={this.props.handleAlert} payment_order_id={this.props.payment_order_id} payment_order_payments_daily_international={this.props.payment_order_payments_daily_international} payment_order_data={this.props.payment_order_data} />
    </Tab>
  </Tabs>
</div>
    );
  }
}

export default PaymentOrdersTrainingTab;



// WEBPACK FOOTER //
// ./src/Components/PaymentOrders/Elements/PaymentOrdersTrainingTab.js